import React from 'react';
import AssignCompanyForm from './AssignCompanyForm';
import { Drawer } from 'src/components/shared/Drawer';
import { useMediaQuery } from '@mui/material';

interface Props {
	openAssignCompanyModal: boolean;
	setOpenAssignCompanyModal: (open: boolean) => void;
	userIds: string[];
	driveId: string;
}

const AssignCompanyModal = ({ openAssignCompanyModal, setOpenAssignCompanyModal, driveId, userIds }: Props) => {
	const isMobile = useMediaQuery('(max-width: 960px)');

	return (
		<div>
			<Drawer
				header={<></>}
				fullWidth={true}
				minHeight='auto'
				isModal={!isMobile}
				isOpen={openAssignCompanyModal}
				onClose={() => setOpenAssignCompanyModal(false)}
				body={
					<AssignCompanyForm driveId={driveId} userIds={userIds} onClose={() => setOpenAssignCompanyModal(false)} />
				}
			/>
		</div>
	);
};

export default AssignCompanyModal;
